import React from 'react'
import TableRowCollapse from './TableRowCollapse'

const TabularContent = () => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className='tabular-content'>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Event Name</th>
            <th>Time</th>
            <th>City</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <button onClick={() => setVisible(prevState => !prevState)} >{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <TableRowCollapse visible={visible} />
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
          <tr>
            <td>
              <button>{'>'}</button>
            </td>
            <td>App Session</td>
            <td>4 minnutes ago</td>
            <td>Lucknow</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default TabularContent
